import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { FloatingLabelComponent } from 'design/floatingLabel';
import { TextInputControlComponent } from 'design/textInputControl';
import { TextComponent } from 'design/text/textComponents';
import {
  PromocodePasswordFormValues,
  PromocodePasswordFormViolation,
} from 'types/promocodePasswordFormTypes';
import { createPromocodePasswordFormViolationLense } from 'utils/promocodePasswordFormUtils';
import { INPUT_PROMOCODE_PASSWORD_MAX_LENGTH } from 'utils/constants';

type Props = {
  values: PromocodePasswordFormValues;
  violations: PromocodePasswordFormViolation[];
  disabled: boolean;
  onPasswordChange(nextValue: string): void;
};

export const PromocodePasswordFieldset = (props: Props) => {
  const { disabled, values, violations, onPasswordChange } = props;

  const {
    inputValidationRequired,
    promocodePasswordEditor: ownDictionary,
  } = useIntlDictionary();

  const passwordHint = React.useMemo(() => {
    for (let violation of violations) {
      switch (violation.name) {
        case 'PasswordIsMissed':
          return inputValidationRequired;
      }
    }
  }, [inputValidationRequired, violations]);

  const passwordIsInvalid = violations.some((violation) =>
    createPromocodePasswordFormViolationLense(violation).isPasswordViolation()
  );

  return (
    <FloatingLabelComponent
      lifted={!!values.password}
      invalid={passwordIsInvalid}
      titleText={
        <TextComponent color="secondary" size="m">
          {ownDictionary.passwordLabelText}
        </TextComponent>
      }
      hintText={
        <TextComponent color="critical" size="s">
          {passwordHint}
        </TextComponent>
      }
    >
      <TextInputControlComponent
        name="password"
        type="password"
        value={values.password}
        disabled={disabled}
        invalid={passwordIsInvalid}
        maxLength={INPUT_PROMOCODE_PASSWORD_MAX_LENGTH}
        onValueChange={onPasswordChange}
      />
    </FloatingLabelComponent>
  );
};
